(() => {
  if (!customElements.get("hero-gallery")) {
    class t extends HTMLElement {
      constructor() {
        super(), this.mediaSlides = this.querySelectorAll("[data-media-index]"), this.triggerElements = this.querySelectorAll("[data-trigger-index]"), 
        this.links = this.querySelectorAll("[data-link-index]"), this.cta = this.querySelector("[data-cta]"), 
        this.urls = JSON.parse(this.querySelector('script[type="application/json"]').textContent), 
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          threshold: .5
        }), this.init();
      }
      init() {
        this.mediaSlides.forEach(t => {
          this.observer.observe(t);
        }), this.links.forEach((t, e) => {
          t.addEventListener("click", t => {
            t.preventDefault();
            const i = this.mediaSlides[e].getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: i,
              behavior: "smooth"
            });
          });
        });
      }
      handleIntersection(t) {
        t.forEach(t => {
          if (t.isIntersecting) {
            const e = t.target.dataset.mediaIndex;
            this.updateActiveSlide(e);
          }
        });
      }
      updateActiveSlide(t) {
        this.links.forEach(e => {
          const i = e.dataset.linkIndex === t;
          e.classList.toggle("opacity-100", i), e.classList.toggle("underline", i), e.classList.toggle("opacity-60", !i);
        }), this.cta && this.urls[t] && (this.cta.href = this.urls[t]);
      }
    }
    customElements.define("hero-gallery", t);
  }
})();